import PropTypes from 'prop-types';
import intl from 'react-intl-universal';
import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';

const propTypes = {
  setAddFriendModalOpen: PropTypes.func.isRequired,
};

const DashboardContactsFriendsTabBar = ({ setAddFriendModalOpen }) => {
  return (
    <div style={{ paddingTop: 10 }}>
      <Grid container spacing={2} direction="column">
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setAddFriendModalOpen(true)}>
          {intl.get('friends_button_add_friend')}
        </Button>
      </Grid>
    </div>
  );
};

DashboardContactsFriendsTabBar.propTypes = propTypes;

export default DashboardContactsFriendsTabBar;
